import Div from '@/shared/Div';
import classNames from 'classnames';
import Image from '@/shared/Image';
import React from 'react';
import dlv from 'dlv';
function StaticImageBanner(props: any) {
  const { height, width, url, alternativeText } = dlv(props, 'image.data.attributes', '');
  return (
    <Image
      width={width}
      height={height}
      className={classNames('w-full h-auto mt-s3 mb-s3')}
      alt={alternativeText}
      src={url}
    />
  );
}

export default React.memo(StaticImageBanner);
